export enum FeatureFlag {
  BREACH_LENSE = 'BREACH_LENSE',
  IDENTECO = 'IDENTECO',
  EXECUTIVE_REPORT = 'EXECUTIVE_REPORT',
  AGGREGATED_REPORT = 'AGGREGATED_REPORT',
  VM_DOWNLOAD = 'VM_DOWNLOAD',
}

export interface CustomerFeatureFlag {
  name: FeatureFlag;
  enabled: boolean;
  preview: boolean;
  paid: boolean;
  beta: boolean;
  activatable: boolean;
}

export const DEMO_FEATURE_FLAGS: CustomerFeatureFlag[] = [
  { name: FeatureFlag.IDENTECO, enabled: true, preview: true, paid: false, beta: false, activatable: true },
  { name: FeatureFlag.BREACH_LENSE, enabled: false, preview: false, paid: false, beta: false, activatable: true },
  { name: FeatureFlag.VM_DOWNLOAD, enabled: true, preview: false, paid: false, beta: false, activatable: true },
];
